"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-thirteen/sections/testimonialSection.tsx */

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type HomeThirteenTestimonialSectionSliderOneItem = {
    /** Detected variants: "Exceptional service a atmosphere. The staff is knowledgeable." | "The entire processfrom placing the order to delivery was seamless." | "Every medicine is well-packed, delivered quickly, proper guidance" | "Authentic products and transparent pricing, they check all the right boxes." */
    text: string;
    /** Detected variants: "Wayne Stafford" | "Linda Oatman" | "Clarence Johnson" | "Denise Tobin" */
    name: string;
    /** Detected variants: "Detroit, MI" | "Minneapolis, MN" | "Atlanta, GA" | "San Antonio, TX" */
    location: string;
};

type HomeThirteenTestimonialSectionSliderTwoItem = {
    /** Detected variants: "Top notch service! Even a query, their support team instantly guided me clearly." | "Exceptional service with the convenience of home delivery. Truly reliable" | "Great service from start to finish. Quick responses and timely delivery." | "A smooth and hassle free experience. Fast delivery & excellent customer care." */
    text: string;
    /** Detected variants: "Michael Smithz" | "Rudy Novack" | "Melissa Walls" | "Walter Donner" */
    name: string;
    /** Detected variants: "San Francisco, CA" | "Nashville, TN" | "Dallas, TX" | "New York, NY" */
    location: string;
};

type TestimonialSectionFasFaStarsItem = {
    key: Key | null | undefined;
    /** Detected variants: "fas fa-star" */
    className?: string;
};

type TestimonialSectionFasFaStars2Item = {
    key: Key | null | undefined;
    /** Detected variants: "fas fa-star" */
    className?: string;
};
export type HomeThirteenTestimonialSectionGeneratedProps = {
    sliderOne?: HomeThirteenTestimonialSectionSliderOneItem[];
    sliderTwo?: HomeThirteenTestimonialSectionSliderTwoItem[];
    /** Default: "What Our Clients Says About Us" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "#" */
    sectionDiv0Div0Link0LinkHref?: string;
    /** Default: "View All" */
    sectionDiv0Div0Link0LinkText?: ReactNode;
    sectionDiv0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    sectionSwiper0SwiperProps?: Partial<ComponentProps<typeof Swiper>>;
    sectionSwiper1SwiperProps?: Partial<ComponentProps<typeof Swiper>>;
    testimonialSectionFasFaStars: TestimonialSectionFasFaStarsItem[];
    testimonialSectionFasFaStars2: TestimonialSectionFasFaStars2Item[];
    testimonialSectionFasFaStarsItemWrapper?: (item: TestimonialSectionFasFaStarsItem, content: ReactNode) => ReactNode;
    testimonialSectionFasFaStarsRenderer?: (defaultNode: ReactNode) => ReactNode;
    testimonialSectionFasFaStars2ItemWrapper?: (item: TestimonialSectionFasFaStars2Item, content: ReactNode) => ReactNode;
    testimonialSectionFasFaStars2Renderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeThirteenTestimonialSectionGenerated: FC<HomeThirteenTestimonialSectionGeneratedProps> = ({
    sliderOne = [],
    sliderTwo = [],
    sectionDiv0Div0H20H2Text = "What Our Clients Says About Us",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0Link0LinkHref = "#",
    sectionDiv0Div0Link0LinkText = "View All",
    sectionDiv0Div0Link0LinkVisible,
    sectionDiv0Div0Link0LinkRenderer,
    sectionDiv0Div0Link0LinkProps,
    sectionSwiper0SwiperProps,
    sectionSwiper1SwiperProps,
    testimonialSectionFasFaStars,
    testimonialSectionFasFaStars2,
    testimonialSectionFasFaStarsItemWrapper,
    testimonialSectionFasFaStarsRenderer,
    testimonialSectionFasFaStars2ItemWrapper,
    testimonialSectionFasFaStars2Renderer,
}) => {
    return (
        <section className="testimonial-section-thirteen section">
            <div className="container">
                <div className="section-header section-header-thirteen">
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                    {renderNode(sectionDiv0Div0Link0LinkVisible, sectionDiv0Div0Link0LinkRenderer, (
                        <SmartLink href={sectionDiv0Div0Link0LinkHref} className="btn theme-12-btn" {...(sectionDiv0Div0Link0LinkProps ?? {})}>
                            {sectionDiv0Div0Link0LinkText}
                            <i className="isax isax-arrow-right-1 ms-2" />
                        </SmartLink>
                    ))}
                </div>
            </div>
            <Swiper modules={[Autoplay, Navigation]} loop={true} speed={2000} autoplay={{
                delay: 3000,
                disableOnInteraction: false,
            }} centeredSlides={false} slidesPerView={3} navigation={{
                prevEl: ".services-prev",
                nextEl: ".services-next",
            }} breakpoints={{
                1400: { slidesPerView: 3, centeredSlides: false },
                1200: { slidesPerView: 3, centeredSlides: false },
                992: { slidesPerView: 2, centeredSlides: false },
                768: { slidesPerView: 1, centeredSlides: false },
                576: { slidesPerView: 1, centeredSlides: false }
            }} className="testimonial-slider-thirteen mb-4" {...(sectionSwiper0SwiperProps ?? {})}>
                {sliderOne.map((item, i) => (
                    <SwiperSlide key={i} className="slide-item">
                        <div className="testimonial-item-thirteen">
                            <p className="description">{item.text}</p>
                            <div className="author-details">
                                <div className="author-info">
                                    <h3 className="author-name">
                                        <SmartLink href="#">{item.name}</SmartLink>
                                    </h3>
                                    <span className="author-location">{item.location}</span>
                                </div>
                                <div className="rating">
                                    <i className="fas fa-star" /><i className="fas fa-star" />
                                    <i className="fas fa-star" /><i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <Swiper modules={[Autoplay]} loop={true} speed={2000} autoplay={{
                delay: 3000,
                disableOnInteraction: false,
            }} slidesPerView={3} centeredSlides={false} breakpoints={{
                1400: { slidesPerView: 3, centeredSlides: false },
                1200: { slidesPerView: 3, centeredSlides: false },
                992: { slidesPerView: 2, centeredSlides: false },
                768: { slidesPerView: 1, centeredSlides: false },
                576: { slidesPerView: 1, centeredSlides: false }
            }} className="testimonials-slider-thirteen" {...(sectionSwiper1SwiperProps ?? {})}>
                {sliderTwo.map((item, i) => (
                    <SwiperSlide key={i} className="slide-item">
                        <div className="testimonial-item-thirteen">
                            <p className="description">{item.text}</p>
                            <div className="author-details">
                                <div className="author-info">
                                    <h3 className="author-name">
                                        <SmartLink href="#">{item.name}</SmartLink>
                                    </h3>
                                    <span className="author-location">{item.location}</span>
                                </div>
                                <div className="rating">
                                    <i className="fas fa-star" /><i className="fas fa-star" />
                                    <i className="fas fa-star" /><i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
};

export default HomeThirteenTestimonialSectionGenerated;
